module.exports = __webpack_public_path__ + "img/DAY2-2.13d28e6f.jpg";